"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSwitcher = void 0;
const react_1 = __importDefault(require("react"));
const index_1 = require("./index");
const styled = __importStar(require("./styled"));
const index_2 = require("../../../../assets/svg-components/index");
const IconSwitcher = ({ platform, fill, link }) => {
    switch (platform) {
        case index_1.SocialNetworks.YOUTUBE:
            return (react_1.default.createElement(styled.Link, { href: link, target: "_blank" },
                react_1.default.createElement(index_2.YouTubeIcon, { fill: fill })));
        case index_1.SocialNetworks.LINKEDIN:
            return (react_1.default.createElement(styled.Link, { href: link, target: "_blank" },
                react_1.default.createElement(index_2.LinkedInIcon, { fill: fill })));
        case index_1.SocialNetworks.FACEBOOK:
            return (react_1.default.createElement(styled.Link, { href: link, target: "_blank" },
                react_1.default.createElement(index_2.FacebookIcon, { fill: fill })));
        case index_1.SocialNetworks.INSTAGRAM:
            return (react_1.default.createElement(styled.Link, { href: link, target: "_blank" },
                react_1.default.createElement(index_2.InstagramIcon, { fill: fill })));
        case index_1.SocialNetworks.TWITTER:
            return (react_1.default.createElement(styled.Link, { href: link, target: "_blank" },
                react_1.default.createElement(index_2.TwitterIcon, { fill: fill })));
        default:
            return null;
    }
};
exports.IconSwitcher = IconSwitcher;
exports.default = exports.IconSwitcher;
